import {Link, useLocation} from "react-router-dom"
import logo256 from "../static-assets/logo-solo-black-256.png"
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome"
import {Fragment, PropsWithChildren, useState, useEffect} from "react"
import {IconProp} from "@fortawesome/fontawesome-svg-core"
import {faGauge, faLink, faCopyright, faUsersRays, faRectangleAd, faUser, faRobot, faRightFromBracket, faBars, faChevronLeft, faWandMagicSparkles, faPeopleArrows} from "@fortawesome/free-solid-svg-icons"
import {use_authenticated_program_state, use_collapsed_navbar} from "./program-state"
import * as C from "./controls"

type page_id = "PAGE-dashboard" | "PAGE-connected-networks" | "PAGE-brands" | "PAGE-audiences" | "PAGE-custom-audiences" | "PAGE-campaigns" | "PAGE-account" | "PAGE-plans" | "PAGE-onboarding" | "PAGE-generator"
type navigation_item = { id : page_id, label : string, icon : IconProp, link? : string, children? : navigation_item[] }

const nav_items : navigation_item[] = [
    { id : "PAGE-dashboard"          , label : "Dashboard" ,        icon : faGauge          , link : "/dashboard" }          ,
    { id : "PAGE-connected-networks" , label : "Networks"  ,        icon : faLink           , link : "/connected-networks" } ,
    { id : "PAGE-brands"             , label : "Brands"    ,        icon : faCopyright      , link : "/brands" }             ,
    { id : "PAGE-audiences"          , label : "Audiences" ,        icon : faUsersRays      , link : "/audiences" }          ,
    { id : "PAGE-custom-audiences"   , label : "Custom Audiences" , icon : faPeopleArrows   , link : "/custom-audiences" }   ,
    { id : "PAGE-campaigns"          , label : "Campaigns" ,        icon : faRectangleAd    , link : "/campaigns" }          ,
    { id : "PAGE-account"            , label : "Account"   ,        icon : faUser           , link : "/account" }            ,
    { id : "PAGE-onboarding"         , label : "Onboarding",     icon : faWandMagicSparkles , link : "/onboarding" }         ,
    // hide for now
    // { id : "PAGE-generator"          , label : "Generator" ,        icon : faRobot          , link : "/generator" }          ,
]
const nav_item_info : Map<page_id, navigation_item> = new Map<page_id, navigation_item>(nav_items.map((item) => [item.id, item]))

const Emit_sub_item = ({item, active_id} : {item : navigation_item, active_id : page_id}) => {
    const is_active = active_id === item.id
    const active_css = is_active ? "active" : ""
    const css_string = `nav-link text-white opacity-10 ${active_css}`

    const handle_click = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (item.link) {
            window.location.href = item.link;
        }
    };
    return (
        <li className="nav-item active">
        {item.link ? (
            <a className={css_string} href={item.link} onClick={handle_click}>
                <span className="sidenav-normal">{item.label}</span>
            </a>
            ) : (
                <span className={css_string}>
                    <span className="sidenav-normal">{item.label}</span>
                </span>
            )}
        </li>

    );
};

const Emit_navbar_group = ({items, active_id, is_collapsed} : {items : navigation_item[], active_id : page_id, is_collapsed : boolean}) => {
    return (
    <li className="nav-item">
        <a data-bs-toggle="collapse" href="#dashboardsExamples" className="nav-link text-white active opacity-10 collapsed" aria-controls="dashboardsExamples" role="button" aria-expanded="false">
            <div className="icon icon-shape icon-sm border-radius-md text-center d-flex align-items-center justify-content-center">
                <svg width="16px" height="16px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" className="color-background"></path>
                    <path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" className="color-background"></path>
                    <path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" className="color-background"></path>
                </svg>
            </div>
            <span className="nav-link-text ms-2">Home</span>
        </a>
        <div className="collapse show" id="dashboardsExamples">
            <ul className="nav border-start ms-4">
                {items.map((item) => (
                    <Emit_navbar_item key={item.id} item={item} active_id={active_id} is_collapsed={is_collapsed}/>
                ))}
            </ul>
        </div>
    </li>)
}

const Emit_navbar_item = ({item, active_id, is_collapsed} : {item : navigation_item, active_id : page_id, is_collapsed : boolean}) => {
  const link = item.link ? item.link : "#";
  const is_active = item.id === active_id;
  const active_style = is_active ? "tw-rounded tw-bg-big-stone-950" : "tw-transition tw-rounded hover:tw-bg-big-stone-950";

  const normal_style = (
    <li className="tw-m-0 tw-p-0">
      <Link to={link} className={`tw-flex tw-items-center tw-py-3 tw-px-3 tw-h-full tw-w-full ${active_style}`}>
          <FontAwesomeIcon icon={item.icon} fixedWidth />
          <span className="tw-ms-2">{item.label}</span>
      </Link>
    </li>
  )

  const collapsed_style = (
    <li className="tw-m-0 tw-p-0 tw-mx-auto">
      <C.Eres_tooltip text={item.label}>
        <Link to={link} className={`tw-flex tw-items-center tw-py-3 tw-px-3 tw-h-full tw-w-full ${active_style}`}>
            <FontAwesomeIcon icon={item.icon} fixedWidth />
        </Link>
      </C.Eres_tooltip>
    </li>
  )

  return is_collapsed ? collapsed_style : normal_style
};

const Emit_navbar_items = ({items, active_id, is_collapsed} : { items: navigation_item[], active_id : page_id, is_collapsed : boolean }) => {
  return (
    <Fragment>
        {items.map((item) => (
            <Emit_navbar_item key={item.id} item={item} active_id={active_id} is_collapsed={is_collapsed} />
        ))}
    </Fragment>
  );
};

export const Emit_navbar = ({active_id, is_collapsed, set_is_collapsed} : {active_id : page_id, is_collapsed: boolean, set_is_collapsed: (v: boolean) => void}) => {

  const handle_toggle = () => {
    set_is_collapsed(!is_collapsed);
  };

  const header = (
      <div className={`tw-flex-none tw-flex tw-flex-col tw-pt-4 tw-pb-2 ${is_collapsed ? "tw-items-center" : "tw-mx-3 tw-items-start"}`}>
          <button onClick={handle_toggle} className="tw-text-white tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-mb-2">
              <FontAwesomeIcon icon={is_collapsed ? faBars : faChevronLeft} />
          </button>
          <Link className="" to="/">
              <img src={logo256} className={`tw-inline-block tw-w-7 tw-bg-white tw-rounded ${is_collapsed ? "" : "tw-ms-0.5 tw-me-2"}`} />
              {!is_collapsed && <span className="tw-text-lg tw-font-bold">eres.io</span>}
          </Link>
      </div>
  );

  return (
      <Fragment>
          <aside className={`tw-fixed tw-inset-y-0 tw-h-full ${is_collapsed ? 'tw-w-16' : 'tw-w-64'} tw-bg-big-stone-rlydark tw-text-sm tw-border-0 tw-text-white tw-m-0 tw-p-0 tw-flex tw-flex-col`}>
              {header}
              <div className="tw-flex-grow tw-overflow-y-auto">
                  <ul className="tw-flex tw-flex-col tw-gap-1 tw-p-0 tw-list-none">
                      <Emit_navbar_items items={nav_items} active_id={active_id} is_collapsed={is_collapsed} />
                  </ul>
              </div>
          </aside>
      </Fragment>
  );
};

const Emit_breadcrumb_item = ({label, to, is_current} : {label : string, to : string, is_current? : boolean}) => {
    const content = is_current ? label : <Link className="" to={to}>{label}</Link>
    const aria_current = is_current ? "page" : undefined
    return <li className="tw-group tw-text-sm tw-inline-block" aria-current={aria_current}>
        <svg className="tw-inline-block group-first:tw-hidden tw-h-4 tw-w-5 tw-flex-shrink-0 tw-text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
        </svg>
        {content}</li>
}

const Emit_alerts = () => {
    return (
            <li className="nav-item dropdown pe-2 d-flex align-items-center">
              <a href="#" className="p-0 nav-link " id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="cursor-pointers">
                  <path fillRule="evenodd" d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z" clip-rule="evenodd"></path>
                </svg>
              </a>
              <ul className="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" aria-labelledby="dropdownMenuButton">
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="py-1 d-flex">
                      <div className="my-auto">
                        <img src="../../assets/img/team-2.jpg" className="avatar avatar-sm  me-3 " alt="user image" />
                      </div>
                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-1 text-sm font-weight-normal">
                          <span className="font-weight-bold">New message</span> from Laur
                        </h6>
                        <p className="mb-0 text-xs text-secondary">
                          <i className="fa fa-clock me-1" aria-hidden="true"></i>
                          13 minutes ago
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="py-1 d-flex">
                      <div className="my-auto">
                        <img src="../../assets/img/small-logos/logo-spotify.svg" className="avatar avatar-sm bg-gradient-dark  me-3 " alt="logo spotify"/>
                      </div>
                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-1 text-sm font-weight-normal">
                          <span className="font-weight-bold">New album</span> by Travis Scott
                        </h6>
                        <p className="mb-0 text-xs text-secondary">
                          <i className="fa fa-clock me-1" aria-hidden="true"></i>
                          1 day
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-radius-md" href="#todo">
                    <div className="py-1 d-flex">
                      <div className="avatar avatar-sm bg-gradient-secondary  me-3  my-auto">
                        <svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <title>credit-card</title>
                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fillRule="nonzero">
                              <g transform="translate(1716.000000, 291.000000)">
                                <g transform="translate(453.000000, 454.000000)">
                                  <path className="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path>
                                  <path className="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-1 text-sm font-weight-normal">
                          Payment successfully completed
                        </h6>
                        <p className="mb-0 text-xs text-secondary">
                          <i className="fa fa-clock me-1" aria-hidden="true"></i>
                          2 days
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
            )
}

const Icon_user_circle = ({className} : {className? : string}) => {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path fillRule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clipRule="evenodd" />
    </svg>
    )
}

export const Icon_settings = ({className} : {className? : string}) => {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path fillRule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z" clipRule="evenodd" />
    </svg>
    )
}

export const format_label = (label: string) => {
  return label.replace(/-/g, ' ');
};


export const Emit_header = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(x => x);
    return (<Fragment>
      <nav className="tw-mx-5 tw-my-0 tw-pt-2 tw-rounded tw-shadow-none tw-flex">
          <nav className="tw-flex-grow" aria-label="breadcrumb">
              <ol className="tw-p-0 tw-m-0">
                  <Emit_breadcrumb_item label="eres.io" to="/" is_current={pathnames.length === 0} />
                  {pathnames.map((value, index) => {
                      const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                      return (
                          <Emit_breadcrumb_item
                              key={to}
                              label={format_label(value)}
                              to={to}
                              is_current={index === pathnames.length - 1}
                          />
                      );
                  })}
              </ol>
          </nav>

          <div>
              <div className="tw-flex tw-text-lynch-500">
                  <div className="tw-relative tw-h-8">
                      <div className="tw-absolute tw-inset-y-0 tw-start-0 tw-flex tw-items-center tw-ps-3 tw-pointer-events-none">
                          <svg className="tw-w-4 tw-h-4 tw-text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                              <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z" clipRule="evenodd" />
                          </svg>
                      </div>
                      <input
                          type="search"
                          className="tw-block tw-h-full tw-w-full tw-ps-10 tw-text-sm tw-border tw-text-black tw-border-gray-300 tw-rounded-lg focus:tw-border-focus-blue focus:tw-ring-0"
                      />
                  </div>
                  <ul className="tw-p-0 tw-m-0 tw-flex tw-items-center">
                      <li className="tw-ps-3"><Icon_settings className="tw-w-5 tw-h-5" /></li>
                      <li className="tw-ps-3"><Link to="/logout"><FontAwesomeIcon icon={faRightFromBracket} /></Link></li>
                  </ul>
              </div>
          </div>
      </nav>
  </Fragment>)
}

const map_lookup = <k, v>(map : Map<k, v>, key : k) : v => {
    const ret = map.get(key)
    if (ret === undefined) throw new Error(`missing key ${key}`)
    return ret
}

const Footer = () => {
    const year : number = new Date().getFullYear();
    return (<footer className="tw-block tw-mt-3 tw-text-slate-500 tw-text-xs tw-w-full tw-pb-[0.5in]">
        <C.Eres_hline className="tw-py-2" />
        <div className="tw-flex tw-flex-row">
            <div>Copyright © {year} Eres, Inc.</div>
            <div className="tw-flex-grow">
            <ul className="tw-flex tw-flex-row tw-gap-3 tw-justify-end">
            <li className=""><a href="https://eres.io/" className="nav-link text-xs text-muted">eres.io</a></li>
            <li className=""><a href="https://eres.io/blog/" className="nav-link text-xs text-muted">learn</a></li>
            </ul>
            </div>
        </div>
    </footer>)
}

export const Emit_main = ({page_id, children} : PropsWithChildren<{page_id : page_id}>) => {
    const [is_collapsed, set_is_collapsed] = use_collapsed_navbar()

    useEffect(() => {
        const handle_resize = () => {
            const is_mobile_or_tablet = window.innerWidth < 1024
            if (is_mobile_or_tablet && !is_collapsed) {
                set_is_collapsed(true)
            } else if (!is_mobile_or_tablet && is_collapsed) {
                set_is_collapsed(false)
            }
        }

        handle_resize()
        window.addEventListener('resize', handle_resize)
        return () => window.removeEventListener('resize', handle_resize)
    }, [is_collapsed, set_is_collapsed])

    return (
      <Fragment>
          <Emit_navbar active_id={page_id} is_collapsed={is_collapsed} set_is_collapsed={set_is_collapsed} />
          <main className={`tw-min-h-screen ${is_collapsed ? 'tw-ml-16' : 'tw-ml-64'} `}>
              <Emit_header />
              <div className="tw-px-5 tw-py-4">
                  {children}
                  <Footer/>
              </div>
          </main>
      </Fragment>
    )
}

export const Emit_placeholder_page = (page_id : page_id) => ({children} : PropsWithChildren<{}>) => {
    use_authenticated_program_state()
    return <Emit_main page_id={page_id}>{children}</Emit_main>
}
